<div class="list">
  <p *ngIf="rType == 0">Selecione uma finalidade para seu recebimento</p>
  <p *ngIf="rType == 1">Selecione uma finalidade para seu envio</p>

  <div
    (click)="select(finality)"
    class="item tappable hover"
    *ngFor="let finality of finalities"
  >
    <div class="row">
      <div class="col-auto padding-left-24 align-self-center">
        <img src="assets/image/market-icon.svg" />
      </div>
      <div [class]="isMobile ? 'col-7' : 'col-8'">
        <div class="d-flex flex-column">
          <p class="name mg-bottom-4">{{ finality.description }}</p>
          <p class="description p-text-grey-scale-dark">
            {{ finality.fullDescription }}
          </p>
        </div>
      </div>
      <div class="col-2 d-flex align-items-center justify-content-end">
        <img src="assets/image/arrow-drawer.svg" />
      </div>
    </div>
  </div>
</div>
